/**
 * Date formatting utilities for the dropbox module
 */

/**
 * Format date as DD MMM YYYY (e.g., "21 Jan 2026")
 */
export const formatDate = (dateString?: string): string => {
  if (!dateString) return '--';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '--';
  
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

/**
 * Format date with time as DD MMM YYYY at HH:MM AM/PM (e.g., "21 Jan 2026 at 3:30 PM")
 */
export const formatDateTime = (dateString?: string): string => {
  if (!dateString) return '--';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '--';
  
  const dateStr = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
  
  const timeStr = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  
  return `${dateStr} at ${timeStr}`;
};

/**
 * Format date for detailed views as DD MMM YYYY, HH:MM AM/PM (e.g., "21 Jan 2026, 3:30 PM")
 */
export const formatDetailedDate = (dateString?: string): string => {
  if (!dateString) return '--';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '--';
  
  const dateStr = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
  
  const timeStr = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  
  return `${dateStr}, ${timeStr}`;
};